// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserDetails_wrapper__2rXU7","profilePhoto":"UserDetails_profilePhoto__v66Db","username":"UserDetails_username__1yGpv"};